import './Line.css'

function Line(){
    return(
        <span className='lined'/>
    )
}

export default Line;